import { isFeatureEnabled } from '@lumapps/features';

import { PLAY_COMMUNITIES_FEATURE_TOKEN } from '../constants';

export const isPlayCommunitiesFeatureEnabled = isFeatureEnabled(PLAY_COMMUNITIES_FEATURE_TOKEN);
